import { render, staticRenderFns } from "./ReportCardSetup.vue?vue&type=template&id=472326e2"
import script from "./ReportCardSetup.vue?vue&type=script&lang=js"
export * from "./ReportCardSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports